var map = {
	"./bitbucket.svg": 91025,
	"./chevron-right.svg": 29610,
	"./circle.svg": 274,
	"./close.svg": 81193,
	"./code.svg": 80657,
	"./database.svg": 77425,
	"./donut.svg": 71506,
	"./external.svg": 33271,
	"./eye-strikethrough.svg": 61199,
	"./eye.svg": 23797,
	"./git.svg": 4530,
	"./github.svg": 43271,
	"./gitlab.svg": 83623,
	"./graphql.svg": 39433,
	"./menu.svg": 43387,
	"./organization.svg": 50811,
	"./packages.svg": 22901,
	"./password.svg": 28913,
	"./permission-small-cross.svg": 99150,
	"./permission-small-tick.svg": 54693,
	"./placeholder.svg": 62153,
	"./plus-circle.svg": 97131,
	"./plus.svg": 28462,
	"./queues.svg": 33274,
	"./retry.svg": 22356,
	"./unknown-user.svg": 67288,
	"./webhook.svg": 8693
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 95317;